export default __webpack_public_path__ + "static/media/A_human_limb.3aabf6c3.png";